/* foyl-restock: our back-in-stock button + popup (replaces STOQ). Behaviour matches STOQ's widget on our store as recorded in
   STOQ-Replication\PARITY.md (sections A-D): same words, fields, validation, errors, success screen and signup request/reply.
   Config comes from snippets/foyl-restock.liquid as window.FoylRestock. No dependencies. */
(function () {
  'use strict';
  var C = window.FoylRestock;
  if (!C || !C.product || window.__foylRestockLoaded) return;
  window.__foylRestockLoaded = true;

  var T = {
    button: 'Notify me When Available', header: 'Notify Me',
    description: 'Get a notification as soon as this product is back in stock by signing up below!',
    submit: 'Notify Me When Available', terms: "We promise we won't spam. You'll only receive notifications for this product.",
    emailPlaceholder: 'Email address', phonePlaceholder: 'SMS', emailLabel: 'Email address',
    success: 'Thank you! We will notify you when the product is available.',
    emptyError: 'Please fill in one or more of the options above', emailError: 'Please enter a valid email address',
    phoneError: 'Please enter a valid phone number', duplicateError: "You've already subscribed for alerts to this product.",
    createError: 'We encountered an issue processing your request. Please try again or contact support if the problem persists.',
    didYouMean: 'Did you mean %{suggested_email}? Or use %{current_email}'
  };
  var EMAIL_RE = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  var PHONE_RE = /^[0-9\-() ]{1,}$/;           // same (loose) client check STOQ uses; the server does the real validation
  var STORE_KEY = 'foyl_restock_customer';
  var DOMAINS = ['gmail.com', 'yahoo.com', 'yahoo.com.au', 'hotmail.com', 'hotmail.com.au', 'outlook.com', 'outlook.com.au', 'live.com',
    'live.com.au', 'icloud.com', 'me.com', 'msn.com', 'aol.com', 'bigpond.com', 'bigpond.net.au', 'optusnet.com.au', 'iinet.net.au',
    'tpg.com.au', 'westnet.com.au', 'internode.on.net', 'ozemail.com.au', 'protonmail.com', 'googlemail.com'];

  var SVG_BELL = '<svg class="foyl-rs-header-icon" width="25" height="25" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path fill-rule="evenodd" fill="currentColor" d="m7.252 14.424-2.446-.281c-1.855-.213-2.38-2.659-.778-3.616l.065-.038a2.887 2.887 0 0 0 1.407-2.48v-.509a4.5 4.5 0 0 1 9 0v.51c0 1.016.535 1.958 1.408 2.479l.065.038c1.602.957 1.076 3.403-.778 3.616l-2.543.292v.365a2.7 2.7 0 0 1-5.4 0v-.376Zm3.9.076h-2.4v.3a1.2 1.2 0 0 0 2.4 0v-.3Z"></path></svg>';
  var SVG_CLOSE = '<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M12.854 3.146a.5.5 0 0 0-.708 0L8 7.293 3.854 3.146a.5.5 0 1 0-.708.708L7.293 8l-4.147 4.146a.5.5 0 0 0 .708.708L8 8.707l4.146 4.147a.5.5 0 0 0 .708-.708L8.707 8l4.147-4.146a.5.5 0 0 0 0-.708z"></path></svg>';
  var SVG_TICK = '<svg class="foyl-rs-success-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path fill="currentColor" d="M13.28 9.03a.75.75 0 0 0-1.06-1.06l-2.97 2.97-1.22-1.22a.75.75 0 0 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.06 0l3.5-3.5Z"></path><path fill="currentColor" fill-rule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"></path></svg>';

  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    for (var k in attrs || {}) if (attrs[k] != null) e.setAttribute(k, attrs[k]);
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function load() { try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null') || {}; } catch (e) { return {}; } }
  function save(v) { try { localStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) { /* private mode */ } }

  // ---------- which variant is selected, and is it sold out ----------
  function currentVariantId() {
    var u = new URLSearchParams(location.search).get('variant');
    var inp = document.querySelector(C.variantSelector || "[name='id']");
    var v = (inp && inp.value) || u || C.selectedVariantId;
    return Number(v) || Number(C.selectedVariantId);
  }
  function variantById(id) { for (var i = 0; i < C.product.variants.length; i++) if (Number(C.product.variants[i].id) === Number(id)) return C.product.variants[i]; return null; }

  // ---------- product page button ----------
  var container = null;
  function ensureButton() {
    var v = variantById(currentVariantId());
    var soldOut = v && !v.available;
    if (!soldOut) { if (container) container.style.display = 'none'; return; }
    if (!container) {
      var anchor = document.querySelector(C.anchorSelector || '.buy-buttons');
      if (!anchor) return;
      container = el('div', { 'class': 'foyl-rs-button-container' });
      var btn = el('button', { type: 'button', 'aria-haspopup': 'dialog', 'class': 'foyl-rs-button' });
      btn.textContent = T.button;
      var cover = el('div', { 'class': 'foyl-rs-button-cover', 'aria-hidden': 'true' });
      container.appendChild(btn); container.appendChild(cover);
      anchor.insertAdjacentElement('afterend', container);
      var openIt = function (e) { e.preventDefault(); openModal(btn); };
      btn.addEventListener('click', openIt); cover.addEventListener('click', openIt);
    }
    container.style.display = '';
  }
  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m];
    history[m] = function () { var r = orig.apply(this, arguments); setTimeout(ensureButton, 0); return r; };
  });
  window.addEventListener('popstate', function () { setTimeout(ensureButton, 0); });
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('form')) setTimeout(ensureButton, 0); }, true);

  // ---------- popup ----------
  var wrapper = null, lastFocus = null, closing = false;
  function closeModal() {
    if (!wrapper || closing) return;
    closing = true;
    wrapper.classList.add('foyl-rs-closing');
    var w = wrapper;
    setTimeout(function () { w.remove(); wrapper = null; closing = false; document.removeEventListener('keydown', onKey); if (lastFocus) lastFocus.focus(); }, 200);
  }
  function onKey(e) {
    if (!wrapper) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key !== 'Tab') return;
    var f = wrapper.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openModal(trigger) {
    if (wrapper) return;
    lastFocus = trigger || document.activeElement;
    var variant = variantById(currentVariantId());
    var known = load();
    var cc = known.country || C.defaultCountry || 'au';
    var options = C.countries.map(function (c) {
      var sel = c[0] === cc;
      return '<option data-country-code="' + c[1] + '"' + (sel ? ' label="' + c[0].toUpperCase() + ' (+' + c[1] + ')" selected' : '') + ' value="' + c[0] + '">' + esc(c[2]) + ' (+' + c[1] + ')</option>';
    }).join('');

    wrapper = el('div', { 'class': 'foyl-rs-wrapper', id: 'foyl-restock' });
    var form = el('div', { id: 'foyl-rs-form', role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'foyl-rs-title', 'aria-describedby': 'foyl-rs-desc', tabindex: '-1' });
    form.innerHTML =
      '<div class="foyl-rs-content">' +
        '<div class="foyl-rs-header">' + SVG_BELL + '<div class="foyl-rs-header-text-container"><h2 class="foyl-rs-header-text" id="foyl-rs-title">' + esc(T.header) + '</h2>' +
          '<button class="foyl-rs-close notranslate" aria-label="Close modal" type="button">' + SVG_CLOSE + '</button></div></div>' +
        '<div class="foyl-rs-description" id="foyl-rs-desc">' + esc(T.description) + '</div>' +
        '<p class="foyl-rs-product-name">' + esc(C.product.title) + '</p>' +
        '<div class="foyl-rs-fields">' +
          '<div class="foyl-rs-phone-row"><select class="foyl-rs-country" aria-label="Country code">' + options + '</select>' +
            '<input class="foyl-rs-input foyl-rs-phone" type="tel" autocomplete="tel-national" placeholder="' + esc(T.phonePlaceholder) + '" aria-label="' + esc(T.phonePlaceholder) + '" value="' + esc(known.national_phone || '') + '"></div>' +
          '<div class="foyl-rs-email-row"><label class="foyl-rs-sr-only" for="foyl-rs-email">' + esc(T.emailLabel) + '</label>' +
            '<input class="foyl-rs-input foyl-rs-email" id="foyl-rs-email" type="email" autocomplete="email" placeholder="' + esc(T.emailPlaceholder) + '" value="' + esc(known.email || C.customerEmail || '') + '"></div>' +
        '</div>' +
        '<div class="foyl-rs-errors"></div>' +
        '<button class="foyl-rs-submit" type="button">' + esc(T.submit) + '</button>' +
        '<div class="foyl-rs-terms">' + esc(T.terms) + '</div>' +
      '</div>';
    wrapper.appendChild(form);
    document.body.appendChild(wrapper);

    var q = function (s) { return form.querySelector(s); };
    var email = q('.foyl-rs-email'), phone = q('.foyl-rs-phone'), country = q('.foyl-rs-country'), submit = q('.foyl-rs-submit'), errors = q('.foyl-rs-errors');
    var suggestionIgnored = false;

    country.addEventListener('change', function () {
      for (var i = 0; i < country.options.length; i++) { var o = country.options[i]; if (o.selected) o.setAttribute('label', o.value.toUpperCase() + ' (+' + o.getAttribute('data-country-code') + ')'); else o.removeAttribute('label'); }
    });
    q('.foyl-rs-close').addEventListener('click', closeModal);
    wrapper.addEventListener('click', function (e) { if (e.target === wrapper) closeModal(); });
    document.addEventListener('keydown', onKey);
    setTimeout(function () { form.focus(); }, 100);

    // Email typo suggestion (shown on blur; never blocks the signup)
    function suggest(domain) {
      var best = null, bestD = 3;
      for (var i = 0; i < DOMAINS.length; i++) { var d = lev(domain, DOMAINS[i]); if (d > 0 && d < bestD) { best = DOMAINS[i]; bestD = d; } }
      return best;
    }
    function lev(a, b) { var m = [], i, j; for (i = 0; i <= a.length; i++) { m[i] = [i]; } for (j = 0; j <= b.length; j++) m[0][j] = j;
      for (i = 1; i <= a.length; i++) for (j = 1; j <= b.length; j++) m[i][j] = Math.min(m[i - 1][j] + 1, m[i][j - 1] + 1, m[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)); return m[a.length][b.length]; }
    function clearSuggestion() { var s = form.querySelector('.foyl-rs-suggestion'); if (s) s.remove(); }
    function checkEmail() {
      var v = email.value.trim();
      clearSuggestion();
      if (!v || v.toLowerCase() === 'alerts@stoqapp.com' || !EMAIL_RE.test(v)) return false;
      var parts = v.split('@'), alt = suggest(parts[1].toLowerCase());
      if (alt && !suggestionIgnored) {
        var s = el('div', { 'class': 'foyl-rs-suggestion' });
        var sug = parts[0] + '@' + alt;
        var html = esc(T.didYouMean).replace('%{suggested_email}', '<span class="foyl-rs-suggestion-link" data-v="' + esc(sug) + '">' + esc(sug) + '</span>')
          .replace('%{current_email}', '<span class="foyl-rs-suggestion-link" data-v="">' + esc(v) + '</span>');
        s.innerHTML = '<span>' + html + '</span>';
        s.addEventListener('click', function (e) {
          var t = e.target.closest('.foyl-rs-suggestion-link'); if (!t) return;
          if (t.getAttribute('data-v')) email.value = t.getAttribute('data-v');
          suggestionIgnored = true; clearSuggestion();
        });
        q('.foyl-rs-email-row').appendChild(s);
      }
      return true;
    }
    email.addEventListener('blur', checkEmail);
    email.addEventListener('input', function () { suggestionIgnored = false; clearSuggestion(); });

    function showErrors(list) {
      errors.innerHTML = '';
      email.classList.toggle('foyl-rs-input-error', list.indexOf('email-error') >= 0);
      [phone, country].forEach(function (x) { x.classList.toggle('foyl-rs-input-error', list.indexOf('sms-error') >= 0); });
      var seen = {};
      list.forEach(function (k) {
        if (seen[k]) return; seen[k] = 1;
        var msg = k === 'empty-error' ? T.emptyError : k === 'email-error' ? T.emailError : k === 'sms-error' ? T.phoneError
          : k === 'duplicate-error' ? T.duplicateError : T.createError + (k.errorId ? ' (Error ID: ' + k.errorId + ')' : '');
        errors.appendChild(el('p', { 'class': 'foyl-rs-error', role: 'alert' }, esc(msg)));
      });
    }

    submit.addEventListener('click', function () {
      var errs = [], cust = { accepts_marketing: false, locale: C.locale || 'en', shopify_market_id: C.marketId || null };
      if (C.customerId) cust.shopify_customer_id = C.customerId;
      var e = email.value.trim(), p = phone.value.trim();
      if (!e && !p) errs.push('empty-error');
      if (e) { if (checkEmail()) cust.email = e; else errs.push('email-error'); }
      if (p) {
        var opt = country.options[country.selectedIndex];
        if (PHONE_RE.test(p)) { cust.phone = '+' + opt.getAttribute('data-country-code') + p; cust.country = opt.value; cust.country_code = opt.getAttribute('data-country-code'); }
        else errs.push('sms-error');
      }
      if (!cust.email && !cust.phone) { showErrors(errs); return; }
      submit.disabled = true;
      var body = {
        intent: { shopify_variant_id: variant.id, shopify_product_id: C.product.id, shopify_market_id: C.marketId || null, country: C.countryIsoCode || 'AU', quantity: 1, source: 'restock-rocket-extension' },
        customer: cust,
        product: { title: C.product.title, variant_title: variant.title, variant_count: C.product.variants.length, vendor: C.product.vendor, sku: variant.sku }
      };
      fetch(C.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) {
          var bad = [], ok = [];
          if (j.errors) {
            if (j.errors.sms_errors) bad.push(j.errors.sms_errors.intent ? 'duplicate-error' : 'sms-error');
            if (j.errors.email_errors) bad.push(j.errors.email_errors.intent ? 'duplicate-error' : 'email-error');
            if (j.errors.already_registered && bad.indexOf('duplicate-error') < 0) bad.push('duplicate-error');
          }
          if (j.intents && j.intents.length) {
            // Like STOQ: remember the whole form as typed, then overwrite with what the reply confirms for each successful channel
            var c = j.intents[0].customer || {}, keep = load(), o = country.options[country.selectedIndex];
            keep.email = email.value.trim(); keep.national_phone = phone.value.trim(); keep.country = o.value; keep.country_code = o.getAttribute('data-country-code');
            j.intents.forEach(function (i) { ok.push(i.channel); });
            if (ok.indexOf('sms') >= 0) { keep.national_phone = c.national_phone; keep.country_code = c.country_code; keep.country = c.country; }
            if (ok.indexOf('email') >= 0) keep.email = c.email;
            save(keep);
          }
          if (ok.length && (!bad.length || bad.every(function (b) { return b === 'duplicate-error'; }))) {
            showSuccess();
            try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('foyl_restock_signup_completed', { variant_id: variant.id, product_id: C.product.id }); } catch (x) { /* optional */ }
            window.dispatchEvent(new CustomEvent('foyl:restock-modal:submitted', { detail: { product_id: C.product.id, variant_id: variant.id } }));
          } else showErrors(bad.length ? bad : ['create-error']);
        })
        .catch(function () { var k = new String('create-error'); k.errorId = 'ERR-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10).toUpperCase(); showErrors([k]); })
        .then(function () { submit.disabled = false; });
    });

    function showSuccess() {
      form.innerHTML = '<div class="foyl-rs-success"><div class="foyl-rs-success-header"><button class="foyl-rs-close notranslate" aria-label="Close modal" type="button">' + SVG_CLOSE +
        '</button></div><div class="foyl-rs-success-body">' + SVG_TICK + '<div class="foyl-rs-success-text">' + esc(T.success) + '</div></div></div>';
      form.querySelector('.foyl-rs-close').addEventListener('click', closeModal);
      form.querySelector('.foyl-rs-close').focus();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensureButton); else ensureButton();
})();
